import { mutations, state as stateTypes } from './types';

export default {
  /**
   * Set dataset.
   * @param {*} state
   * @param {*} dataset
   */
  [mutations.SET_DATASET](state, dataset) {
    state[stateTypes.DATASET] = dataset;
  },
  /**
   * Set collection.
   * @param {*} state
   * @param {*} collection
   */
  [mutations.SET_COLLECTION](state, collection) {
    state[stateTypes.COLLECTION] = collection;
  },
  /**
   * Set subjects with attributes.
   * @param {*} state
   * @param {*} subjects
   */
  [mutations.SET_SUBJECTS](state, subjects) {
    state[stateTypes.SUBJECTS] = subjects;
  },
  /**
   * Set subject variables.
   * @param {*} state
   * @param {*} variables
   */
  [mutations.SET_SUBJECT_VARIABLES](state, variables) {
    state[stateTypes.SUBJECT_VARIABLES] = variables;
  },
  /**
   * Set observation variables.
   * @param {*} state
   * @param {*} variables
   */
  [mutations.SET_OBSERVATION_VARIABLES](state, variables) {
    state[stateTypes.OBSERVATION_VARIABLES] = variables;
  },
  /**
   * Set observation variables.
   * @param {*} state
   * @param {*} variables
   */
  [mutations.SET_SELECTED_VARIABLES](state, variables) {
    state[stateTypes.SELECTED_VARIABLES] = variables;
  },
  /**
   * Set variables.
   * @param {*} state
   * @param {*} dataset
   */
  [mutations.SET_VARIABLES](state, variables) {
    state[stateTypes.VARIABLES] = variables;
  },
  /**
   * Set variable sparkline data.
   * @param {*} state
   * @param {*} dataset
   */
  [mutations.SET_VARIABLE_DATA](state, variable_data) {
    state[stateTypes.VARIABLE_DATA] = variable_data;
  },
  /**
   * Set use long scale names.
   * @param {Object} state
   * @param {String} useLong to use long scale names
   */
  [mutations.SET_USE_LONG_SCALE_NAMES](state, useLong) {
    state[stateTypes.USE_LONG_SCALE_NAMES] = useLong;
  },
  /**
   * Set enable variable selection.
   * @param {Object} state
   * @param {String} flag to enable variable selection
   */
  [mutations.SET_ENABLE_VARIABLE_SELECTION](state, flag) {
    state[stateTypes.ENABLE_VARIABLE_SELECTION] = flag;
  },
  /**
   * Set is study dataset.
   * @param {Object} state
   * @param {String} whether summarizing loaded dataset or user-created study dataset
   */
  [mutations.SET_IS_COLLECTION](state, is_collection) {
    state[stateTypes.IS_COLLECTION] = is_collection;
  },
  /**
   * Set visit variable.
   * @param {*} state
   * @param {*} newFirstVisits
   */
  [mutations.SET_VISIT_VARIABLE](state, newVisitVariable) {
    state[stateTypes.VISIT_VARIABLE] = newVisitVariable;
  },
  /**
   * Set first visit variables.
   * @param {*} state
   * @param {*} newFirstVisits
   */
  [mutations.SET_FIRST_VISITS](state, newFirstVisits) {
    state[stateTypes.FIRST_VISITS] = newFirstVisits;
  },
  /**
   * Set last visit variables.
   * @param {*} state
   * @param {*} newLastVisit
   */
  [mutations.SET_LAST_VISITS](state, newLastVisits) {
    state[stateTypes.LAST_VISITS] = newLastVisits;
  },
  /**
   * Set visit summaries.
   * @param {*} state
   * @param {*} visit_summaries
   */
  [mutations.SET_VISIT_SUMMARIES](state, visit_summaries) {
    state[stateTypes.VISIT_SUMMARIES] = visit_summaries;
  },
  /**
   * Set times between visits.
   * @param {*} state
   * @param {*} newTimesVar
   */
  [mutations.SET_TIMES_BETWEEN_VISITS](state, newTimesVar) {
    state[stateTypes.TIMES_BETWEEN_VISITS] = newTimesVar;
  },
  /**
   * Set number of selected subjects.
   * @param {*} state
   * @param {*} newSelectedSubjectsVar
   */
  [mutations.SET_NUM_SELECTED_SUBJECTS](state, newSelectedSubjectsVar) {
    state[stateTypes.NUM_SELECTED_SUBJECTS] = newSelectedSubjectsVar;
  },
  /**
   * Increment request number and return the result via callback.
   * @param {Object} state
   */
  [mutations.INCREMENT_TIMES_BETWEEN_VISITS_REQUEST_NUM](state, { callback }) {
    state[stateTypes.TIMES_BETWEEN_VISITS_REQUEST_NUM] =
      state[stateTypes.TIMES_BETWEEN_VISITS_REQUEST_NUM] + 1;
    callback(state[stateTypes.TIMES_BETWEEN_VISITS_REQUEST_NUM]);
  },
  [mutations.RESET_TIMES_BETWEEN_VISITS_REQUEST_NUM](state) {
    state[stateTypes.TIMES_BETWEEN_VISITS_REQUEST_NUM] = 0;
  },
};
